module.exports = __webpack_public_path__ + "_/img/MapMarker3.df539409.svg";